import { useQuery } from '@tanstack/react-query';
import { getAll, getPaginated, get, api } from '../../lib/api';

export const useGetPaginatedClients = ({
  page,
  itemsPerPage,
  sortBy,
  sortDirection,
  filter,
}) =>
  useQuery(
    ['clients', page, itemsPerPage, sortBy, sortDirection, filter],
    () =>
      getPaginated('/api/client_admin/clients')(
        page,
        itemsPerPage,
        sortBy,
        sortDirection,
        filter,
      ),
    { keepPreviousData: true },
  );

export const useGetAllClients = ({ sortBy, sortDirection, filter }) =>
  useQuery(
    ['clients', sortBy, sortDirection, filter],
    () => getAll(`/api/client_admin/clients`)(sortBy, sortDirection, filter),
    {
      keepPreviousData: true,
    },
  );

export const addSeats = () => get('/api/client_admin/clients/add_seats');

export const editClientDate = ({ id, beginsAt, endsAt }) => {
  return api.put(`/api/client_admin/campaigns/boards/${id}`, {
    demo: {
      begins_at: beginsAt,
      ends_at: endsAt,
    },
  });
};

export const editClient = ({ data, id }) => {
  return api({
    method: 'put',
    url: `/api/client_admin/campaigns/boards/${id}`,
    data,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const archiveCampaign = uuid => {
  return api.patch(`/api/client_admin/campaigns/boards/${uuid}/archive`, {});
};

export const unarchiveCampaign = ({ uuid }) => {
  return api.patch(`/api/client_admin/campaigns/boards/${uuid}/unarchive`, {});
};

export const duplicateCampaign = ({ id }) => {
  return api.post(`/api/client_admin/campaigns/boards/${id}/duplicate`, {});
};

export const createVbfBoard = ({ data }) => {
  return api({
    method: 'post',
    url: '/api/client_admin/campaigns/boards',
    data,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const createTemplate = ({ templateName }) => {
  return api({
    method: 'post',
    url: '/api/client_admin/campaigns/template_boards',
    data: { demo: { template_name: templateName } },
  });
};

export const editTemplate = ({ templateId }) => {
  return api({
    method: 'get',
    url: `/api/client_admin/campaigns/template_boards/${templateId}/edit`,
  });
};

export const useGetClientsList = () => {
  const {
    data: { clients },
    isFetching,
  } = useQuery(
    ['clientsList'],
    () => get('/api/client_admin/campaigns/clients'),
    {
      refetchOnWindowFocus: false,
      initialData: {
        clients: [],
      },
    },
  );

  return {
    clients,
    isFetching,
  };
};
